import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { LangProvider } from "@/context/LangContext";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import InsightDetail from "@/pages/InsightDetail";
import ProductDetail from "@/pages/ProductDetail";
import ProductDemo from "@/pages/ProductDemo";
import ProductTour from "@/pages/ProductTour";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import AdminLogin from "@/pages/admin/Login";
import Partners from "@/pages/Partners";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LeadsAdmin from "@/pages/admin/Leads";
import ContentAdmin from "@/pages/admin/ContentAdmin";
import InsightsAdmin from "@/pages/admin/InsightsAdmin";
import InsightEditor from "@/pages/admin/InsightEditor";
import CurrencyAdmin from "@/pages/admin/CurrencyAdmin";
import Media from "@/pages/admin/Media";
import { PRETTY_TO_SLUG } from "@/lib/productRoutes";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <CurrencyProvider>
          <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/products/:slug/demo" element={<ProductDemo />} />
            <Route path="/products/:slug/tour" element={<ProductTour />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            {Object.entries(PRETTY_TO_SLUG).map(([pretty, canonical]) => (
              <Route
                key={pretty}
                path={`/${pretty}`}
                element={<ProductDetail overrideSlug={canonical} prettySlug={pretty} />}
              />
            ))}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<LeadsAdmin />} />
              <Route path="products" element={<ContentAdmin type="products" />} />
              <Route path="web-packages" element={<ContentAdmin type="web-packages" />} />
              <Route path="hosting-plans" element={<ContentAdmin type="hosting-plans" />} />
              <Route path="marketing-tiers" element={<ContentAdmin type="marketing-tiers" />} />
              <Route path="case-studies" element={<ContentAdmin type="case-studies" />} />
              <Route path="careers" element={<ContentAdmin type="careers" />} />
              <Route path="global-reach" element={<ContentAdmin type="global-reach" />} />
              <Route path="insights" element={<InsightsAdmin />} />
              <Route path="insights/new" element={<InsightEditor />} />
              <Route path="insights/:id/edit" element={<InsightEditor />} />
              <Route path="currency" element={<CurrencyAdmin />} />
              <Route path="media" element={<Media />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CurrencyProvider>
      </LangProvider>
    </div>
  );
}

export default App;
